// extracted by mini-css-extract-plugin
module.exports = {"LoadingRoot":"PrescriptionDownloader_LoadingRoot__s969Q","LoadingWrapper":"PrescriptionDownloader_LoadingWrapper__1TRfa","GridList":"PrescriptionDownloader_GridList__2sOBU"};